import { defineStore } from 'pinia'
import { computed, watch } from 'vue'
import { useStore } from 'vuex'

export const useAccessToken = defineStore('access_token', () => {
  const store = useStore()
  const token = computed<string | undefined>(() => store?.state.oidcStore.access_token)
  const bearer = computed(() => (token.value ? `Bearer ${token.value}` : undefined))
  watch(
    token,
    (newToken) => {
      if (newToken) {
        localStorage.setItem('currentKeycloakToken', newToken)
      }
    },
    { immediate: true }
  )

  return { token, bearer }
})
